import { Pressable, PressableProps } from "react-native";
import { cn } from "../../lib/utils";

export function TabButton(props: PressableProps) {
  return (
    <Pressable
      {...props}
      className={cn(
        "items-center justify-center rounded-2xl border border-gray-200 bg-white p-6 active:bg-gray-300",
        props.className
      )}
    />
  );
}
